export const normalizeString = (value: string | undefined): string => value || '';

export const waitForStateChange = async (
    checkFn: () => boolean,
    timeout: number = 7500,
    interval: number = 100,
): Promise<void> => {
    return new Promise((resolve, reject) => {
        const startTime = Date.now();

        const check = () => {
            if (checkFn()) {
                resolve();
            } else if (Date.now() - startTime > timeout) {
                reject(new Error('State change timeout'));
            } else {
                setTimeout(check, interval);
            }
        };

        check();
    });
};
